import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/all'
import Swiper from 'swiper/bundle'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

function faqs() {
  const faqs = document.querySelector('[data-name="faqs"]')

  if (faqs) {
    const tabs = faqs.querySelectorAll('[data-name="faq-title"]')
    const panels = faqs.querySelectorAll('[data-name="accordion-wrapper"]')
    const sticky = faqs.querySelector('[data-name="sticky-tabs"]')
    const triggers = faqs.querySelectorAll('[data-target="accordion"]')

    if (window.innerWidth < 1024) {
      const slider = faqs.querySelector('[data-name="tabs-slider"]')
      const slides = faqs.querySelectorAll('.swiper-slide')
      const pagination = faqs.querySelector('.pagination')

      const tabsSlider = new Swiper(slider, {
        slidesPerView: 1.5,
        slidesPerGroup: 1,
        initialSlide: 0,
        spaceBetween: 30,
        slidesOffsetBefore: 40,
        pagination: {
          el: pagination,
          type: 'fraction',
        },
        breakpoints: {
          640: {
            slidesPerView: 2.5,
            spaceBetween: 30,
          },
        },
      })

      tabsSlider.on('slideChange', function () {
        switchTab(tabsSlider.realIndex)
      })

      slides.forEach(function (slide, index) {
        slide.addEventListener('click', function () {
          var clickedIndex = index

          var activeIndex = tabsSlider.realIndex

          if (
            clickedIndex === activeIndex + 1 ||
            (activeIndex === slides.length - 1 && clickedIndex === 0)
          ) {
            tabsSlider.slideNext()
          } else if (
            clickedIndex === activeIndex - 1 ||
            (activeIndex === 0 && clickedIndex === slides.length - 1)
          ) {
            tabsSlider.slidePrev()
          }
        })
      })
    } else {
      if (window.innerWidth > 1025) {
        ScrollTrigger.create({
          trigger: faqs,
          start: 'top top',
          end: 'bottom bottom',
          pin: sticky,
        })
      }
    }

    function switchTab(targetTab) {
      panels.forEach((panel, index) => {
        if (index === targetTab) {
          gsap.to(panel, {
            autoAlpha: 1,
            y: 0,
            duration: 0.5,
            ease: 'power2.out',
            onStart: () => {
              panel.style.display = 'block'
            },
          })
          tabs[index].classList.add('active-tab')
        } else {
          gsap.to(panel, {
            autoAlpha: 0,
            y: 150,
            duration: 0.5,
            ease: 'power2.out',
            onStart: () => {
              panel.style.display = 'none'
            },
          })
          tabs[index].classList.remove('active-tab')
        }
      })
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        switchTab(index)

        const faqsBounds = faqs.getBoundingClientRect()

        gsap.to(window, {
          duration: 0.5,
          scrollTo: { y: '#faqs' },
          delay: 0.05,
        })
      })
    })

    switchTab(0)
  }
}

export default faqs
